module.exports = __webpack_public_path__ + "static/media/mobile_mockup_2.59bc6fde.png";